const price_guide = {
  headline: 'Electrical Services Price Guide',
  content:
    "Understanding the costs associated with electrical services is a crucial step in maintaining the safety and functionality of your space. In the below guide, we'll demystify the pricing of various electrical services, giving you the knowledge to make informed decisions the next time you need to call an electrician.",
  data: [
    {
      label: 'Installing a new light fixture',
      cost: '$50 - $200 per fixture'
    },
    {
      label: 'Replacing a circuit breaker',
      cost: '$100 - $250 per breaker'
    },
    {
      label: 'Adding a new electrical outlet',
      cost: '$100 - $200 per outlet'
    },
    {
      label: 'Installing a ceiling fan',
      cost: '$100 - $300 per fan'
    },
    {
      label: 'Upgrading an electrical panel',
      cost: '$1,000 - $3,000'
    },
    {
      label: 'Installing a new circuit',
      cost: '$200 - $500 per circuit'
    },
    {
      label: 'Repairing a faulty electrical outlet',
      cost: '$75 - $150 per outlet'
    },
    {
      label: 'Installing a new doorbell',
      cost: '$100 - $250'
    },
    {
      label: 'Replacing a light switch',
      cost: '$50 - $150 per switch'
    },
    {
      label: 'Installing outdoor lighting',
      cost: '$200 - $500 per fixture'
    },
    {
      label: 'Installing a whole-house surge protector',
      cost: '$500 - $1,000'
    },
    {
      label: 'Repairing an electrical short circuit',
      cost: '$200 - $500'
    },
    {
      label: 'Installing a new smoke detector',
      cost: '$50 - $150 per detector'
    },
    {
      label: 'Rewiring a house',
      cost: '$3,000 - $20,000 or more'
    },
    {
      label: 'Troubleshooting electrical issues',
      cost: '$100 - $300 per hour'
    }
  ]
};

export default price_guide;
